export const CARD_BG = 'https://static.fuxi.netease.com/yaotai/portal/20220627/l4wbrt3k_card-art.png';
export const CARD_TEXT = [
  '传统的线下艺术展受到时间与空间的双重限制，准备流程较长，需要涉及到场地租赁、供应商选择、展厅搭建、艺术品搬运等繁琐环节，耗时、耗力、且花费成本较大，还面临活动延期的风险。',
  '网易瑶台线上办展可支持后台自定义装修，满足场景化风格设计，还可大大节省成本，充分发挥主办方在人力、物力、时间上的最大效用，并且所覆盖的人群更广，内容传播更高效。',
];

export const DEMANDS = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypax_icon2.png',
    title: '场景定制',
    text: '结合主办方需求，定制个性化场景装修及其它看展功能，带来最佳沉浸式的观展感受。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5ugpfsg_403696.png',
    title: '多维互动',
    text: '通过音视频畅聊、私信、名片交换等多种互动方式，使线上艺术展厅无限逼近线下真实体验。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypay_icon3.png',
    title: '藏品展示',
    text: '依托 AI 技术，在线全方位呈现艺术展品特色，打造与观众独特的 1v1 互动。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5uftnbp_920469.png',
    title: '创意玩法',
    text: '结合活动需求，策划艺术展内容设计，打造超级营销事件，创意玩法赋能活动影响力升级。',
  },
];

export const FEATURES = [
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220907/l7r5842t_285732.png',
    title: '高效的活动流程管理',
    desc: [
      '后台快捷创建活动信息，自由设置活动时间，提前完成展馆装修',
      '一站式完成活动邀约、素材收集、场地部署、观众报名、门票发送、会议控场、数据分析等活动全流程管理',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1m_920378.png',
    title: '个性化的场地和服装',
    desc: [
      '高精度复刻线下艺术展馆、展厅、展台、展品等，满足艺术展场地需求',
      '更多创意场景随心定制，古风、火星、沙漠、山川、海底，用虚拟世界的情景来实现天马行空的创意，在想象的空间里展现更多艺术形式',
      '支持定制统一的看展服装、座椅贴、引导牌等服饰和装修',
    ],
  },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hdzpas_348116.png',
    title: '沉浸式的交流感官体验',
    desc: [
      'AI 智能捏脸，随心打造用户专属虚拟分身；表情动作实时同步到虚拟角色，让情感表达变得更真实',
      '在线畅聊、视频交流、作品讲解、虚实相融的交互体验快速建立与艺术家、艺术展品间的通道',
    ],
  },
  // {
  //   rightText: false,
  //   image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1j_920375.png',
  //   title: '多维度数据统计分析',
  //   desc: [
  //     '签到、互动等数据统计，实时监控艺术展效果',
  //     '展后满意度数据、点赞次数、观看人数统计等多维度统计报表，用数据体现艺术的传播',
  //   ],
  // },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7igzaul_834413.png',
    title: '高质量的业务价值提升',
    desc: ['为展商、赞助商提供多方位品牌内容展示', '整合多渠道传播资源提升活动宣传效果'],
  },
];

export const ADVANTAGES = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd7_icon3.png',
    title: '一站式服务',
    text: '瑶台一站式全流程技术服务，满足艺术展在前期、中期、后期各环节的多样性需求，助力主办方提升活动组织与运营效率。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5ugwwu1_752377.png',
    title: '沉浸式活动体验',
    text: '通过虚实相融的交互体验，快速建立用户与艺术家、艺术展品三者的通道；瑶台提供多元场地风格和多层次多维度的场景配置，给予视觉震撼。',
  },
  // {
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd6_icon2.png',
  //   title: '品牌价值',
  //   text: '网易集团的品牌背书，上市企业的整合资源背景。瑶台依托于网易在 3D 游戏引擎、AI、云计算等领域的多年积累，强大的技术实力保障平台安全稳定。',
  // },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd8_icon4.png',
    title: '创新活动形式',
    text: '结合主办方需求，创新式还原并改进线下艺术展；多种花样玩法让活动更有趣；虚实结合、零距离、沉浸式，让展台充满无限可能；参与艺术展品的内容包装及优化，助力影响力延伸。',
  },
];

export const SUCCESS_CASES = [
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '【生态守护映像】沉浸式公益摄影展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85h_132357.png',
    brief:
      // autocorrect: false
      '2022年6月9日-10日，网易伏羲旗下沉浸式活动平台网易瑶台携手青海省玉树藏族自治州称多县政协，顺利举办 2022“生态守护映像”沉浸式公益生态摄影展，以科技赋能公益，为自然生态保护点燃微光。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '网易星球元宇宙艺术展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85i_132358.png',
    brief:
      // autocorrect: false
      '2022年6月，网易星球与 BFC 强强联手，将艺术盛典搬进元宇宙，使用沉浸式活动平台网易瑶台内的展馆场景，打造“2022 网易星球首届元宇宙艺术季”。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '【生态守护映像】沉浸式公益摄影展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85h_132357.png',
    brief:
      // autocorrect: false
      '2022年6月9日-10日，网易伏羲旗下沉浸式活动平台网易瑶台携手青海省玉树藏族自治州称多县政协，顺利举办 2022“生态守护映像”沉浸式公益生态摄影展，以科技赋能公益，为自然生态保护点燃微光。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '网易星球元宇宙艺术展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85i_132358.png',
    brief:
      // autocorrect: false
      '2022年6月，网易星球与 BFC 强强联手，将艺术盛典搬进元宇宙，使用沉浸式活动平台网易瑶台内的展馆场景，打造“2022 网易星球首届元宇宙艺术季”。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '【生态守护映像】沉浸式公益摄影展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85h_132357.png',
    brief:
      // autocorrect: false
      '2022年6月9日-10日，网易伏羲旗下沉浸式活动平台网易瑶台携手青海省玉树藏族自治州称多县政协，顺利举办 2022“生态守护映像”沉浸式公益生态摄影展，以科技赋能公益，为自然生态保护点燃微光。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '网易星球元宇宙艺术展',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220810/l6n0r85i_132358.png',
    brief:
      // autocorrect: false
      '2022年6月，网易星球与 BFC 强强联手，将艺术盛典搬进元宇宙，使用沉浸式活动平台网易瑶台内的展馆场景，打造“2022 网易星球首届元宇宙艺术季”。',
  },
];
